export default __webpack_public_path__ + "static/media/cta3.2b5be0ef.png";